import { render, staticRenderFns } from "./CrmDialog.vue?vue&type=template&id=2f556c72"
import script from "./CrmDialog.vue?vue&type=script&lang=ts"
export * from "./CrmDialog.vue?vue&type=script&lang=ts"
import style0 from "./CrmDialog.vue?vue&type=style&index=0&id=2f556c72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports